import styled from "styled-components";

export const V3Vid = styled.video<{ isFullScreen: boolean, maxHeight?: number }>`
    width: 100%;
    height: auto;
    max-height: ${({ maxHeight, isFullScreen }) => {
        if (isFullScreen) return "100vh";
        if (!isFullScreen && maxHeight) return `${maxHeight}px`;
        return null;
    }};
    top: ${({ isFullScreen }) => isFullScreen ? '50%;' : null};
    transform: ${({ isFullScreen }) => isFullScreen ? 'translateY(-50%);' : null};
    position: ${({ isFullScreen }) => isFullScreen ? 'relative' : 'absolute'};
`;

export const V3VidControls = styled.ul<{ show?: boolean }>`
    display:  ${({ show }) => show ? 'flex' : 'none'};
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    padding: 12px 15px;
    max-width: calc(100% - 40px);
    width: 100%;
    border-radius: 100px;
    align-items: center;
    border-radius: 6px;
    background: #FFFFFF;
    box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.2);
    height: 36px;

    > li {
        display: inline-flex;
        margin-right: 16px;

        &:nth-child(2),
        &:nth-child(4) {
            min-width: 39px;
        }

        &:nth-child(3) {
            margin-right: 8px;
            flex: 1;
        }

        svg {
            &:hover {
                cursor: pointer;
            }
        }
    }
`;


export const V3VidWrapper = styled.div<{ isFullScreen: boolean, hideMouse: boolean }>`
    height: ${({ isFullScreen }) => !isFullScreen ? "0" : null};
    padding-bottom: ${({ isFullScreen }) => !isFullScreen ? " 56.25%;" : null};
    cursor: ${({ hideMouse }) => hideMouse ? 'none' : null};
    display: inline-block;
    position: relative;
    width: 100%;
    background: black;
`;

export const VolumeRockerWrapper = styled.div`
    padding: 6px 4px;
    width: 18px;
    height: 80px;
    background: rgba(255, 255, 255, 0.3);
    border: 0.5px solid rgba(244, 244, 246, 0.2);
    border-radius: 14px;
`;

export const VolumeRange = styled.div`
    width: 68px;
    transform: translate(-30px, 24px) rotate(-90deg);
`;

export const V3VideoLoaderPos = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
`;